module.exports = __webpack_public_path__ + "img/electron.43ec3bdb.svg";